module.exports = "https://coursera_assets.s3.amazonaws.com/images/3af0b046be630e08fb60c579d10ca119.png";